/* eslint-disable camelcase */
import React from "react";
import Text from "../../../../../atoms/Text";
import Icons from "./icons";

const {
  EmarIcon,
  FamilyIcon,
  GroupsIcon,
  ProIcon,
  OutstandingIcon,
  StarterIcon,
} = Icons;

// N/A for plan lookup is for not used anymore, but we keep it for record that we know in CO that is not used
// StarterIcon same situation for icons

const iconLookup = {
  // Existing plans
  pro: ProIcon,
  "pro-monthly": ProIcon,
  "pro-annual": ProIcon,
  "pro-annual-bespoke": ProIcon,
  "pro-monthly-bespoke": ProIcon,
  "care-plans": StarterIcon,
  "e-mar": EmarIcon,
  "emar-annual": EmarIcon,
  "emar-annual-bespoke": EmarIcon,
  "emar-monthly-bespoke": EmarIcon,
  groups: GroupsIcon,
  "groups-monthly": GroupsIcon,
  "groups-annual": GroupsIcon,
  "groups-annual-bespoke": GroupsIcon,
  "groups-monthly-bespoke": GroupsIcon,
  family: FamilyIcon,
  "family-monthly": FamilyIcon,
  "family-annual": FamilyIcon,
  // New plans
  "Painchek---yearly-plan-GBP-Yearly": ProIcon,
  "Homecare---Pro-yearly-plan-GBP-Yearly": ProIcon,
  "Homecare---Pro-monthly-plan-GBP-Monthly": ProIcon,
  "Homecare---Outstanding-yearly-plan-GBP-Yearly": OutstandingIcon,
  "Homecare---Outstanding-monthly-plan-GBP-Monthly": OutstandingIcon,
  "Family---yearly-plan-GBP-Yearly": FamilyIcon,
  "Family---monthly-plan-GBP-Monthly": FamilyIcon,
  "Emar---yearly-plan-GBP-Yearly": EmarIcon,
  "Emar---monthly-plan-GBP-Monthly": EmarIcon,
  "Elderly---Pro-yearly-plan-GBP-Yearly": ProIcon,
  "Elderly---Pro-monthly-plan-GBP-Monthly": ProIcon,
  "Elderly---Outstanding-yearly-plan-GBP-Yearly": OutstandingIcon,
  "Elderly---Outstanding-monthly-plan-GBP-Monthly": OutstandingIcon,
  "Complex-Care---Pro-yearly-plan-GBP-Yearly": ProIcon,
  "Complex-Care---Pro-monthly-plan-GBP-Monthly": OutstandingIcon,
  "Complex-Care---Outstanding-yearly-plan-GBP-Yearly": OutstandingIcon,
  "Complex-Care---Outstanding-monthly-plan-GBP-Monthly": OutstandingIcon,
  "homecare-pro-gbp-monthly": ProIcon,
  "homecare-outstanding-gbp-yearly": OutstandingIcon,
  "homecare-outstanding-gbp-monthly": OutstandingIcon,
  "elderly-pro-gbp-yearly": ProIcon,
  "elderly-pro-gbp-monthly": ProIcon,
  "elderly-outstanding2-gbp-yearly": OutstandingIcon,
  "elderly-outstanding-gbp-monthly2": OutstandingIcon,
  "complex-care-pro-gbp-monthly": ProIcon,
  "complex-care-outstanding-gbp-monthly": OutstandingIcon,
  "complex-care-outstanding-gbp-yearly": OutstandingIcon,
  "extra-painchek-gbp-yearly": ProIcon,
  "extra-family-gbp-yearly": FamilyIcon,
  "extra-family-gbp-monthly": FamilyIcon,
  "extra-emar-gbp-yearly": EmarIcon,
  "extra-emar-gbp-monthly": EmarIcon,
  "crappy-GBP-Monthly": StarterIcon,
  "addon-painchek-gbp-yearly": ProIcon,
  "elderly-outstanding-gbp-yearly": OutstandingIcon,
  "elderly-outstanding-gbp-monthly": OutstandingIcon,
  "homecare-pro-gbp-yearly": ProIcon,
  "addon-family-gbp-yearly": FamilyIcon,
  "addon-family-gbp-monthly": FamilyIcon,
  "addon-emar-gbp-yearly": EmarIcon,
  "addon-emar-gbp-monthly": EmarIcon,
  "complex-care-pro-gbp-yearly": ProIcon,
  "Outstanding-Plan---Test---Annual-2024-AO-GBP-Yearly": StarterIcon,
  "Outstanding-Plan---Test---Annual-2024-GBP-Yearly": StarterIcon,
  "Annual-Plan-Test-2024-GBP-Yearly": StarterIcon,
  "Pro-Service-user-GBP-Monthly": StarterIcon,
  "Outstanding-Test-anna-GBP-Monthly": StarterIcon,
  "Trial-GBP-Monthly": StarterIcon,
};

const planLookup = {
  // Existing plans
  pro: "Pro Plan",
  "pro-monthly": "Pro Monthly Plan",
  "pro-monthly-bespoke": "Pro Annual Plan - Monthly payments",
  "pro-annual": "Pro Annual Plan",
  "pro-annual-bespoke": "Pro Annual Plan",
  "care-plans": "N/A",
  "e-mar": "eMAR",
  "emar-annual": "eMAR",
  groups: "Outstanding plan",
  "groups-annual": "Outstanding Annual Plan",
  "groups-monthly": "Outstanding Monthly Plan",
  "groups-annual-bespoke": "Outstanding Monthly Plan",
  "groups-monthly-bespoke": "Outstanding Monthly Plan",
  family: "Family",
  "family-monthly": "Family Monthly Plan",
  "family-monthly-bespoke": "Family Annual Plan",
  "family-annual": "Family Annual Plan",
  // New plans
  "Painchek---yearly-plan-GBP-Yearly": "Painchek - Annual Plan",
  "Homecare---Pro-yearly-plan-GBP-Yearly": "Homecare - Pro Annual Plan",
  "Homecare---Pro-monthly-plan-GBP-Monthly": "Homecare - Pro Monthly Plan",
  "Homecare---Outstanding-yearly-plan-GBP-Yearly":
    "Homecare - Outstanding Annual Plan",
  "Homecare---Outstanding-monthly-plan-GBP-Monthly":
    "Homecare - Outstanding Monthly Plan",
  "Family---yearly-plan-GBP-Yearly": "Family - Annual Plan",
  "Family---monthly-plan-GBP-Monthly": "Family - Monthly Plan",
  "Emar---yearly-plan-GBP-Yearly": "Emar - Annual Plan",
  "Emar---monthly-plan-GBP-Monthly": "Emar - Monthly Plan",
  "Elderly---Pro-yearly-plan-GBP-Yearly": "Elderly - Pro Annual Plan",
  "Elderly---Pro-monthly-plan-GBP-Monthly": "Elderly - Pro Monthly Plan",
  "Elderly---Outstanding-yearly-plan-GBP-Yearly":
    "Elderly - Outstanding Annual Plan",
  "Elderly---Outstanding-monthly-plan-GBP-Monthly":
    "Elderly - Outstanding Monthly Plan",
  "Complex-Care---Pro-yearly-plan-GBP-Yearly": "Complex Care - Pro Annual Plan",
  "Complex-Care---Pro-monthly-plan-GBP-Monthly":
    "Complex Care - Pro Monthly Plan",
  "Complex-Care---Outstanding-yearly-plan-GBP-Yearly":
    "Complex Care - Outstanding Annual Plan",
  "Complex-Care---Outstanding-monthly-plan-GBP-Monthly":
    "Complex Care - Outstanding Monthly Plan",
  "homecare-pro-gbp-monthly": "Homecare - Pro Annual Plan",
  "homecare-outstanding-gbp-yearly": "Homecare - Outstanding Annual Plan",
  "homecare-outstanding-gbp-monthly": "Homecare - Outstanding Monthly Plan",
  "elderly-pro-gbp-yearly": "Elderly - Pro Annual Plan",
  "elderly-pro-gbp-monthly": "Elderly - Pro Monthly Plan",
  "elderly-outstanding2-gbp-yearly": "Elderly - Outstanding Annual Plan",
  "elderly-outstanding-gbp-monthly2": "Elderly - Outstanding Monthly Plan",
  "complex-care-pro-gbp-monthly": "Complex Care - Pro Annual Plan",
  "complex-care-outstanding-gbp-monthly":
    "Complex Care - Outstanding Monthly Plan",
  "complex-care-outstanding-gbp-yearly":
    "Complex Care - Outstanding Annual Plan",
  "extra-painchek-gbp-yearly": "Painchek - Annual Plan",
  "extra-family-gbp-yearly": "Family - Annual Plan",
  "extra-family-gbp-monthly": "Family - Monthly Plan",
  "extra-emar-gbp-yearly": "Emar - Annual Plan",
  "extra-emar-gbp-monthly": "Emar - Monthly Plan",
  "crappy-GBP-Monthly": "N/A",
  "addon-painchek-gbp-yearly": "Painchek - Annual Plan",
  "elderly-outstanding-gbp-yearly": "Elderly - Outstanding Annual Plan",
  "elderly-outstanding-gbp-monthly": "Elderly - Outstanding Monthly Plan",
  "homecare-pro-gbp-yearly": "Homecare - Pro Annual Plan",
  "addon-family-gbp-yearly": "Family - Annual Plan",
  "addon-family-gbp-monthly": "Family - Monthly Plan",
  "addon-emar-gbp-yearly": "Emar - Annual Plan",
  "addon-emar-gbp-monthly": "Emar - Monthly Plan",
  "complex-care-pro-gbp-yearly": "Complex Care - Pro Annual Plan",
  "Outstanding-Plan---Test---Annual-2024-AO-GBP-Yearly": "N/A",
  "Outstanding-Plan---Test---Annual-2024-GBP-Yearly": "N/A",
  "Annual-Plan-Test-2024-GBP-Yearly": "N/A",
  "Pro-Service-user-GBP-Monthly": "N/A",
  "Outstanding-Test-anna-GBP-Monthly": "N/A",
  "Trial-GBP-Monthly": "N/A",
};

type PlanProps = {
  planId: string;
};

export const Plan = ({ planId }: PlanProps) => (
  <>
    {/* @ts-ignore */}
    <div style={styles.icon}>{iconLookup[planId]}</div>
    <Text style={styles.text}>
      {/* @ts-ignore */}
      <strong>{planLookup[planId] || planId}</strong>
    </Text>
  </>
);

const styles = {
  icon: { height: 34 },
  text: { lineHeight: 0 },
};

export default Plan;
